import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { LightThemeColors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import PaymentMethodCard from '../PaymentMethodCard';
import SectionTitle from '../SectionTitle';

import styles from './PreferredPaymentMethod.Styles';

function PreferredPaymentMethod({ preferredCard, onCardPress, isLoading }) {
  const theme = useTheme() || LightThemeColors;
  return (
    <View style={styles.preferredCard}>
      <SectionTitle title="payment_preferred_payment_methods" />
      <PaymentMethodCard
        cardTestID={FrameworkTestKeys.PreferedCardID}
        isLoading={isLoading}
        onCardPress={onCardPress}
        card={preferredCard}
      />
      <View style={styles.divider(theme)} />
    </View>
  );
}
PreferredPaymentMethod.propTypes = {
  preferredCard: PropTypes.object,
  onCardPress: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default PreferredPaymentMethod;
